module.exports = __webpack_public_path__ + "static/media/Delivary in 45 days.5d771c2a.svg";